<template>
    <div class="select-channel" v-tooltip="'ID kanału: ' + channel.id">
        <img v-if="channel.group.icon"  class="server-group-icon"  :src="'assets/groupIcons/' + channel.group.sgid + '.png'">
        <font-awesome-icon v-else data-toggle="tooltip" :title='channel.group.name' class="server-group-icon" icon="image" style="margin-bottom: 0px;"/>
        <div class="info">
            <span>{{ channel.group.name }}</span><br>
            <small v-if="channel.type == 'owner'">Jesteś właścicielem</small>
            <small v-else>Masz dostęp</small>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SelectChannel",
        props: {
            channel: Object,
        },
    }
</script>

<style scoped>
    .select-channel {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-around;
        align-items: center;
        background: rgba(0,0,0,0.1);
        padding: 15px 50px;
        margin: 10px;
        text-align: center;
        border-radius: 5px;
        font-weight: bold;
        cursor: pointer;
        transition: all .2s ease-in-out;
    }

    .select-channel:hover {
        background: rgba(0,0,0,0.3);
    }

    .select-channel .server-group-icon {
        width: 24px;
        height: 24px;
        margin: 5px 20px;
    }

    .select-channel .info {
        text-align: center;
    }
</style>